export const META_TITLE_WARNING_LENGTH = 60;

export const normalizeMetaTitle = (title?: string | null): string | null => {
  const normalized = title?.replace(/\s+/g, " ").trim();
  return normalized || null;
};

export const validateMetaTitle = (title?: string | null): true | string => {
  if (title && !normalizeMetaTitle(title)) {
    return "Meta title cannot contain only whitespace. Clear the field to use the post title.";
  }

  return true;
};

/** Shared by metadata and admin previews so the default and suffix stay identical. */
export const getSEOTitle = (title?: string, brandSuffix = true): string =>
  title
    ? brandSuffix
      ? `${title} | Dreambound`
      : title
    : "Dreambound - Education For Your Future";

export const getGeneratedMarketplaceTitle = (providerName: string, programName?: string): string =>
  getSEOTitle(programName === undefined ? providerName : `${programName} - ${providerName}`);
